export default __webpack_public_path__ + "static/media/banner3.932f0091.png";